<template>
    <!-- Explanatory copy with no control (e.g. the MKT report variation
         descriptions). Carries no settings key. -->
    <div class="py-2">
        <p  v-if="field.label"
            class="m-0 text-left text-sm font-medium text-gray-700">
            {{ field.label }}
        </p>
        <p class="m-0 text-left text-sm text-gray-500">{{ field.text }}</p>
    </div>
</template>

<script>
export default {
    name: "ReportProseField",
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
}
</script>
